import React from 'react';
import { FaBook, FaCode } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';
import './SellerOptions.css';

const SellerOptions = () => {
    const navigate = useNavigate();

    const handleGoBack = () => {
        window.history.back();
    };

    const goToCodeLogin = () => {
        navigate('/code-login');
    };

    const goToTutorials = () => {
        navigate('/tutorials');
    };


    return (
        <div className="seller-options">
            <img src={logo} alt="Logo de BearMax" className="company-logo" />
            <h1 className="title">Panel de Control de Vendedor</h1>
            <p className="subtitle">
                Accede a tutoriales detallados y obtén códigos de las plataformas de streaming principales de manera fácil y rápida.
            </p>
            
            <div className="options-container">
                <div className="option-card">
                    <div className="icon">
                        <FaBook />
                    </div>
                    <h3>Tutoriales</h3>
                    <p>
                        Aprende a usar nuestros servicios con guías paso a paso 
                        con videos explicativos.
                    </p>
                    <button className="btn" onClick={goToTutorials}>Ver Tutoriales</button>
                </div>
                
                <div className="option-card">
                    <div className="icon">
                        <FaCode />
                    </div>
                    <h3>Obtener Códigos</h3>
                    <p>
                        Obtén los códigos de tus servicios streaming disponibles.
                    </p>
                    <button className="btn" onClick={goToCodeLogin}> Obtener Códigos  </button>
                </div>
            </div>
             <div className="options-container">
            <button className="go-back-btn" onClick={handleGoBack}>
               ← Regresar al Inicio
            </button>
           
  

             </div>

            <div className="options-container">
                <footer className="footer">
                <p>© {new Date().getFullYear()} BearMax - Todos los derechos reservados</p>
            </footer>
            </div>

        </div>
    );
};

export default SellerOptions;